import React, { useRef } from 'react';
import { Tooltip, SvgIcon, IconButton, FormGroup } from '@material-ui/core';
import { Sun as LightIcon, Moon as DarkIcon } from 'react-feather';
import useSettings from 'src/hooks/useSettings';
import { THEMES } from 'src/constants';
import { restoreSettings } from 'src/contexts/SettingsContext';

const CustomizedSwitch = () => {
  const restoredSettings = restoreSettings();
  const theme = (restoredSettings && restoredSettings.theme) || THEMES.LIGHT;
  const ref = useRef(null);
  const { saveSettings } = useSettings();

  const handleSwitch = (theme) => {
    saveSettings({ theme: THEMES[theme] });
  };

  return (
    <FormGroup>
      {theme === THEMES.LIGHT ? (
        <Tooltip title="Dark mode">
          <IconButton
            color="inherit"
            ref={ref}
            onClick={() => handleSwitch(THEMES.ONE_DARK)}
          >
            <SvgIcon>
              <DarkIcon />
            </SvgIcon>
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Light mode">
          <IconButton
            color="inherit"
            ref={ref}
            onClick={() => handleSwitch(THEMES.LIGHT)}
          >
            <SvgIcon>
              <LightIcon />
            </SvgIcon>
          </IconButton>
        </Tooltip>
      )}
    </FormGroup>
  );
};

export default CustomizedSwitch;
